import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Want me to talk at your event? ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Get in touch")
const _hoisted_3 = { class: "section pt-5 px-3 px-lg-0" }
const _hoisted_4 = { class: "container isotope" }
const _hoisted_5 = { class: "container position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_Filters = _resolveComponent("Filters")
  const _component_Talk = _resolveComponent("Talk")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_PageHeader, { title: "Talks" }, {
      tagline: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_router_link, {
          class: "link-on-bg text-link",
          to: { name: 'contact' }
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode("section", _hoisted_3, [
      _createVNode(_component_Filters, {
        name: "talk-filters",
        filters: _ctx.talkFilters
      }, null, 8, ["filters"]),
      _createVNode(_component_Filters, {
        name: "language-filters",
        filters: _ctx.languageFilters
      }, null, 8, ["filters"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.talks, (talk) => {
            return (_openBlock(), _createBlock(_component_Talk, {
              key: talk.id,
              class: "isotope-item",
              talk: talk
            }, null, 8, ["talk"]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}